import React,{useState,useRef, useEffect} from 'react'
import { ref, onValue,push, set,remove} from "firebase/database";
import database from "../firebase";
import Header from './Header'
export default function Doctors() {
  document.title = "Doctors";
  let doctorElementRef=useRef()
  let[loader,setLoader]=useState(true)
  const[doctors,setDoctors]=useState([])
  let addDoctor=function(e){
    e.preventDefault()
    console.log(doctorElementRef.current.value)
    const DoctorsRef = ref(database, "Doctors");
    const newDoctorRef = push(DoctorsRef);
    return set(newDoctorRef, {
      name: doctorElementRef.current.value,
      date: new Date()
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"),
    });
  }
  const handleDelete = (id) => {
    const DoctorRef = ref(database, `Doctors/${id}`);
    remove(DoctorRef)
      .then(() => {
        console.log(`doctor ${id} deleted successfully.`);
        setDoctors((prevDoctors) => prevDoctors.filter((doc) => doc.id !== id)); // Update local state
      })
      .catch((error) => {
        console.error("Error deleting doctor:", error);
      });
  };
  useEffect(() => {
    const DoctorsRef = ref(database, "Doctors");
    const unsubscribe = onValue(
      DoctorsRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const formattedData = Object.entries(data).map(([id, values]) => ({
            id,
            ...values,
          }));
         
          setDoctors(formattedData);
          setLoader(false)
          
        } else {
          setDoctors([]);
       
        }
      },
      (error) => {
        setLoader(false)
        console.error("Error fetching Doctors:", error);
      }
    );
    return () => unsubscribe();
  },[])
  return (
    <div>
<Header />
<section>
  <h3 className='text-center mt-4'>Doctors Mangement</h3>
<form className=" col-md-10 mx-auto" onSubmit={addDoctor}>
            {/* name input */}
            <div className=" container input-group mb-3">
              <input
                type="text"
                className={`form-control }`}
                name="Name"
                id="Name"
                placeholder="enter the doctor name"
                aria-describedby="inputGroupPrepend2"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("برجاء ادخال اسم  صحيح")
                }
                onInput={(e) => e.target.setCustomValidity("")}
               ref={doctorElementRef}
              />
            </div>
           
             <div className='text-center mt-3'> <button className={`btn btn-dark m-auto`}>Add now</button></div>
    </form>
</section>
<section className='container'>
  {loader&&<div className='text-center mt-4'><div className="spinner-border" role="status">
  
</div>
<p className=''>Getting data</p></div> }
  {doctors.map((doc)=>{
    return(
      <div className="card m-2" key={doc.id}>
      <div className="card-body d-flex justify-content-between align-items-center">
        <h5 className="card-title">{doc.name}</h5>
    <button className='btn btn-danger' onClick={()=>handleDelete(doc.id)}>DEL</button>
      </div>
    </div>
    )
  })}
</section>
    </div>
  )
}
